module.exports = __webpack_public_path__ + "media/images/close-10a6aad4910aa2b895321424f4d094ac.svg";